module.exports = __webpack_public_path__ + "img/badge_color_pop-research.42f1a544.svg";